import angular from 'angular';

module.exports = angular.module('common.models.subscription', [
  require('angular-resource')
])
.factory('Subscription', function($resource) {
  return $resource('/api/v1/subscriptions');
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/models/subscription.js
 **/